import React, { Suspense } from 'react'
import PropTypes from 'prop-types'

import FullPageLoader from '~/components/fullpage-loader/fullpage-loader'
import { Container, Flex } from '@grupoboticario/flora-react'

export default function DefaultLayout({ children }) {
  return (
    <Flex
      css={{
        width: '100%',
        justifyContent: 'center',
        overflowX: 'hidden'
      }}
    >
      <Container centerContent size='large'>
        <Suspense fallback={<FullPageLoader />}>{children}</Suspense>
      </Container>
    </Flex>
  )
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired
}
